import { Nullable } from 'global';
import { z } from 'zod';

export const PHONE_REGEX = /^\(\d{3}\) \d{3}-\d{4}$/;

export const validationMessages = {
  email: 'Invalid email (e.g. example@mail.com)',
  phone: 'Invalid phone format (e.g. (555) 123-4567)',
  ssn: 'Invalid SSN (e.g. 123-45-6789)',
} as const;

export const isValidSSN = (value?: Nullable<string>) => {
  if (!value) return false;
  const digits = value.replace(/-/g, '');
  return (
    /^(?!000|666|9\d{2})\d{3}-(?!00)\d{2}-(?!0000)\d{4}$/.test(value) &&
    !/^(\d)\1{8}$/.test(digits) &&
    digits !== '123456789'
  );
};

export const emailSchema = z.string().email(validationMessages.email).trim().toLowerCase();

export const phoneSchema = z.string().trim().regex(PHONE_REGEX, validationMessages.phone);

export const ssnSchema = z.string().trim().refine(isValidSSN, validationMessages.ssn);
